import { render, staticRenderFns } from "./ExtendedLayout.vue?vue&type=template&id=3fecf25c&"
import script from "./ExtendedLayout.vue?vue&type=script&lang=js&"
export * from "./ExtendedLayout.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports